import { RefObject, useEffect } from 'react';
import {
  Outlet,
  useMatch,
  useNavigate,
  useOutletContext,
  // useLocation,
} from 'react-router-dom';
import { SendMessage } from 'react-use-websocket';
import { Tabs, apiAbortController } from '@ui/src';
import { useAppSelector, useAppDispatch } from '@store';
import { setScrolled, setSelectedChannel } from './store/slices/general';

import ROUTES from '../routes';

import cn from './messages.module.css';

const MessagesMain = () => {
  const {
    selectedUserId,
    sendMessage,
    scrollRef,
    search,
    connectionStatus,
    prevConnectionStatus,
  } = useOutletContext<{
    selectedUserId?: string;
    sendMessage: SendMessage;
    scrollRef: RefObject<HTMLDivElement | null>;
    search?: string;
    connectionStatus?: string;
    prevConnectionStatus?: string;
  }>();

  const match = useMatch(ROUTES.MESSAGES_MAIN);
  const navigate = useNavigate();

  const {
    // mainChannelsPagination,
    // mainChannelsByTypeIsLoading,
    selectedChannel,
  } = useAppSelector((state) => state.messages.general);

  const dispatch = useAppDispatch();

  // const { pathname } = useLocation();

  useEffect(() => {
    if (match) {
      navigate(ROUTES.MESSAGES_MAIN_UNREAD);
    }
  }, [match]);

  useEffect(() => {
    let title = 'Messages: Main';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  return (
    <>
      <div className={cn.messagesTabsWrapper}>
        <Tabs
          itemClassName={cn.messagesTabsItem}
          onRouterClick={() => {
            apiAbortController.abortPendingRequest();

            dispatch(setScrolled(false));

            if (selectedChannel) {
              dispatch(setSelectedChannel(undefined));

              sendMessage(
                JSON.stringify({
                  event: 'unsubscribe',
                  data: { channelId: selectedChannel.id },
                }),
              );
            }
          }}
          tabs={[
            {
              name: (
                <div
                  className={`${cn.messageTabItemTitle} ${cn.messageSubTabItemTitle}`}
                >
                  {/* {`Unread ${
                    pathname.includes(ROUTES.MESSAGES_MAIN_UNREAD) &&
                    !mainChannelsByTypeIsLoading &&
                    mainChannelsPagination
                      ? `(${mainChannelsPagination?.totalCount})`
                      : ''
                  }`} */}
                  Unread
                </div>
              ),
              path: `${ROUTES.MESSAGES_MAIN_UNREAD}${search || ''}`,
            },
            {
              name: (
                <div
                  className={`${cn.messageTabItemTitle} ${cn.messageSubTabItemTitle}`}
                >
                  In Progress
                  {/* {`In Progress ${
                    pathname.includes(ROUTES.MESSAGES_MAIN_IN_PROGRESS) &&
                    !mainChannelsByTypeIsLoading &&
                    mainChannelsPagination
                      ? `(${mainChannelsPagination?.totalCount})`
                      : ''
                  }`} */}
                </div>
              ),
              path: `${ROUTES.MESSAGES_MAIN_IN_PROGRESS}${search || ''}`,
            },
            {
              name: (
                <div
                  className={`${cn.messageTabItemTitle} ${cn.messageSubTabItemTitle}`}
                >
                  Inactive
                </div>
              ),
              path: `${ROUTES.MESSAGES_MAIN_COMPLETED}${search || ''}`,
            },
            {
              name: (
                <div
                  className={`${cn.messageTabItemTitle} ${cn.messageSubTabItemTitle}`}
                >
                  All
                </div>
              ),
              path: `${ROUTES.MESSAGES_MAIN_ALL}${search || ''}`,
            },
          ]}
          enableRouting
        />
      </div>
      <Outlet
        context={{
          selectedUserId,
          sendMessage,
          scrollRef,
          search,
          connectionStatus,
          prevConnectionStatus,
        }}
      />
    </>
  );
};

export default MessagesMain;
